import {
  GET_SIGNAL_TABLE,
  GET_SIGNAL_TRENDS,
  GET_SIGNAL_EMERGING,
  GET_SIGNAL_FILTER_OPTIONS,
  GET_SIGNAL_RECORDS,
  CREATE_SIGNAL_RECORD,
  UPDATE_SIGNAL_RECORD,
  GET_DESIGNATED_TERMS,
  CREATE_DESIGNATED_TERM,
  DELETE_DESIGNATED_TERM,
  GET_DETECTION_RUNS,
  REVIEW_DETECTION_RUN,
} from '../types'

const initialState = {
  overview: null,
  signals: [],
  pagination: { page: 1, pageSize: 25, total: 0, totalPages: 1 },
  trends: [],
  emerging: [],
  filterOptions: { drugs: [], adverse_events: [] },
  records: [],
  designatedTerms: [],
  detectionRuns: [],
}

const signalAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SIGNAL_TABLE:
      return {
        ...state,
        overview: action.payload?.overview || null,
        signals: action.payload?.signals || [],
        pagination: action.payload?.pagination || initialState.pagination,
      }

    case GET_SIGNAL_TRENDS:
      return { ...state, trends: action.payload || [] }

    case GET_SIGNAL_EMERGING:
      return { ...state, emerging: action.payload || [] }

    case GET_SIGNAL_FILTER_OPTIONS:
      return { ...state, filterOptions: action.payload || initialState.filterOptions }

    case GET_SIGNAL_RECORDS:
      return { ...state, records: action.payload || [] }

    case CREATE_SIGNAL_RECORD:
      return { ...state, records: [action.payload, ...state.records] }

    case UPDATE_SIGNAL_RECORD:
      return {
        ...state,
        records: state.records.map((r) => (r.id === action.payload?.id ? action.payload : r)),
      }

    case GET_DESIGNATED_TERMS:
      return { ...state, designatedTerms: action.payload || [] }

    case CREATE_DESIGNATED_TERM:
      return { ...state, designatedTerms: [action.payload, ...state.designatedTerms] }

    case DELETE_DESIGNATED_TERM:
      return {
        ...state,
        designatedTerms: state.designatedTerms.filter((t) => t.id !== action.payload),
      }

    case GET_DETECTION_RUNS:
      return { ...state, detectionRuns: action.payload || [] }

    case REVIEW_DETECTION_RUN:
      return {
        ...state,
        detectionRuns: state.detectionRuns.map((r) =>
          r.id === action.payload?.id ? action.payload : r,
        ),
      }

    default:
      return state
  }
}

export default signalAnalysisReducer
